<template>
    <div>
        <compFormEdit :col="1" ref="validForm" :formdata="getBase" v-model="formData"></compFormEdit>
        <compMutiUpload v-bind="getFileProps" @on-success="handleSuccess" @on-cancel="$emit('on-close')">
            <div class="margin-bottom-15 color-error" slot="footer">
                <p>1、刷评资源的附件请以资源ID号@自定义后缀命名，比如1@二维码</p>
                <p>2、选择更新，则同一个ID如果再次导入新文件，会将该资源已存在的附件覆盖；</p>
                <p>3、选择新增，则不会覆盖该预选已存在的附件，为新插入一条。</p>
            </div>
        </compMutiUpload>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpBatchUploadMeta
} from "@/service/products/brushreview";
export default {
    props: ['id'],
    data () {
        return {
            loading: false,
            formData: {
                type: 1
            }
        }
    },
    computed: {
        getBase () {
            return [
                {
                    label: "请选择方式",
                    key: "type",
                    tag: "vRadio",
                    options: [
                        {
                            label: "更新",
                            trueValue: 0
                        },
                        {
                            label: "新增",
                            trueValue: 1
                        }
                    ]
                }

            ]
        },
        getFileProps () {
            return {
                data: {
                    srcLabel: 0,
                    model: "brushreview_resource",
                    type: "other",
                },
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                multiple: true,
                beforeUpload: (fileList) => {
                    // 查看页直接传入id，不用检查文件名
                    if (this.id) return true;
                    for (let i = 0; i < fileList.length; i ++) {
                        if (!this.checkFileName(fileList[i].name)) {
                            this.$VMessage.error(`${fileList[i].name}的文件名格式有误，请以资源ID号@自定义后缀命名，比如1@二维码`);
                            return false;
                        }
                    }
                    return true;
                    // if (fileList.length > 5) {
                    //     this.$VMessage.error("附件数量过多，请打包后上传");
                    //     return false;
                    // } else {
                    //     return true;
                    // }
                },
            };
        }
    },
    methods: {
        checkFileName (name) {
            let exp = /\d{1,}@.{1,}/g;
            return exp.test(name);
        },
        findIdByName (fileName) {
            let exp = /@.{1,}/g;
            return fileName.replace(exp, "");
        },
        async handleSuccess (attachContent) {
            this.loading = true;
            let fileList = attachContent.items.map(item => {
                return {
                    id: this.id || this.findIdByName(item.attachBrief),
                    fileName: item.attachBrief,
                    meta: JSON.stringify({
                        items: [item],
                        opAt: item.attachOpAt,
                        organizationId: global.SYSID,
                    })
                }
            });
            await HttpBatchUploadMeta({
                contextId: global.SYSID,
                ...this.formData,
                items: fileList
            }).then(res => {
                this.$VMessage.success(res.message);
                this.$emit('on-update');
            }, err => {
                this.$VMessage.error(err.message);
            });
            this.loading = false;
        },
    }
}
</script>

<style>

</style>